import { FC } from 'react';
import cn from 'classnames';

import { PsychicLabel } from 'constants/enums';
import { getPsychicLabel } from 'src/shared/lib/psychics';
import Icon from 'src/shared/ui/Icon';
import { camalifyKebab } from 'lib/text.service';

import styles from './PsychicCardLabel.module.scss';

import { IPsychicCardLabel } from '../config/declarations';

const labelIndexes = new Map<PsychicLabel, number>()
  .set(PsychicLabel.RISING_STAR, 0)
  .set(PsychicLabel.PREMIER, 1)
  .set(PsychicLabel.NEW, 2)
  .set(PsychicLabel.STAFF_PICK, 3)
  .set(PsychicLabel.CUSTOMER_PICK, 4)
  .set(PsychicLabel.ELITE, 5)
  .set(PsychicLabel.SELECT, 6)
  .set(PsychicLabel.VERIFIED, 7);

const PsychicCardLabel: FC<IPsychicCardLabel> = ({
  psychic,
  psychicFrame,
  className,
}) => {
  const labelsSprite = psychicFrame.labelsCollection?.items;
  const labelIcon = labelsSprite?.find((item) => item?.slug === 'labels-desktop');
  const slug = getPsychicLabel(psychic) || PsychicLabel.VERIFIED;

  if (!slug) {
    return null;
  }

  const labelIndex = labelIndexes.get(slug) ?? labelIndexes.get(PsychicLabel.VERIFIED) ?? 0;
  const labelText = psychicFrame.abilities?.split(',')?.[labelIndex] || null;

  if (!labelText && !labelIcon?.image) {
    return null;
  }

  return (
    <div
      className={cn(styles.badge, className)}
      data-label={slug}
    >
      {labelIcon?.image && (
        <Icon
          image={labelIcon.image}
          className={cn(styles.icon, styles[camalifyKebab(slug)])}
        />
      )}
      {labelText && (
        <span className={styles.text}>
          {labelText}
        </span>
      )}
    </div>
  );
};

export default PsychicCardLabel;
